// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_ll-0";
export var discountCodeInput = "_ll-1";